<template lang="html">


<!-- AMPLIAR -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="12" viewBox="0 0 12 12">
    <defs>
        <path id="a" d="M0 0h12v12H0z"/>
    </defs>
    <g>
        <mask id="b" :fill="colors.basic">
            <use xlink:href="#a"/>
        </mask>
        <path :fill="colors.basic" d="M12 11.485v-3.53h-1.018v3.027H8.128V12h3.357a.525.525 0 0 0 .515-.515zm-12 0c0 .277.225.502.502.502h3.476v-1.018h-2.96V7.956H0v3.529zM12 .515a.502.502 0 0 0-.502-.502h-3.37v1.018h2.854v2.788H12V.515zM.515 0h3.476v1.018H1.017v2.788H0V.516C0 .237.238 0 .515 0z"/>
    </g>
</svg>



</template>

<script lang="js">
  
  import {mapGetters} from 'vuex';

  export default  {
    name: 'add',
    props: [],
    computed : {
      ...mapGetters({
        colors : 'basicColors'
      })
    }
}
</script>

<style scoped lang="scss">
  .add {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/icons/ampliar.vue